import { render, staticRenderFns } from "./TaskWorkerAssignments.vue?vue&type=template&id=7f578dbc&"
import script from "./TaskWorkerAssignments.vue?vue&type=script&lang=js&"
export * from "./TaskWorkerAssignments.vue?vue&type=script&lang=js&"
import style0 from "./TaskWorkerAssignments.vue?vue&type=style&index=0&id=7f578dbc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports